import React from "react";
import { Button } from "@/components/ui/button";

export const SchedulingSection = () => {
  return (
    <section id="zakazivanje" className="bg-[var(--bg-page)] py-24">
      <div className="max-w-[87.5rem] mx-auto px-5 lg:px-10">
        <div className="max-w-2xl mb-8">
          <p className="caption text-[var(--text-secondary)]">ZAKAZIVANJE</p>
          <h2 className="heading-2 text-[var(--text-primary)] mb-4">
            Online zakazivanje tehničkog pregleda
          </h2>
          <p className="body-medium text-[var(--text-primary)]">
            Izaberite datum i termin koji vam odgovara.
          </p>
        </div>

        <div className="bg-[var(--bg-card)] border border-[var(--border-light)] rounded-xl p-8 flex flex-col items-center justify-center gap-6 text-center">
          <p className="body-small text-[var(--text-secondary)] max-w-xl">
            Klikom na dugme otvorićete stranicu za online zakazivanje tehničkog pregleda u novom prozoru.
          </p>
          <a
            href="https://superregistracija.azurewebsites.net/zakazitehnickiframe.aspx?t=CY8zN2LOYwz1UAJRs2ctA9XoTuoVWDNbR7XmpHeDJmRwyLbNXJ0paHdk6Jz8oOwVsvRrMeb1%2byAd2yKUDTaMiC8RxlffDn%2b%2f%2by8BvGauJCg%3d"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex"
          >
            <Button className="btn-primary px-8 py-3 text-sm font-semibold whitespace-nowrap">
              ZAKAŽI TEHNIČKI PREGLED
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SchedulingSection;
